// @flow

import * as React from 'react';
import i18n from 'app/common/lib/i18n';
import hoverable, { type hoverHandlersType } from 'app/common/lib/react/hoverable';
import { Box, Icon, Text, Touchable } from 'gestalt';

type CreateBoardButtonProps = {
  buttonLabel?: string,
  hasHoverState?: boolean,
  hoverHandlers: hoverHandlersType,
  isHovering: boolean,
  isRowItem?: boolean,
  name?: string,
  onClick: () => void,
};

export function CreateBoardButton(props: CreateBoardButtonProps) {
  const { buttonLabel, isHovering, isRowItem, hasHoverState, hoverHandlers, name, onClick } = props;
  const text = name || buttonLabel || i18n._('Create board');

  return (
    <Touchable
      onMouseEnter={hoverHandlers.onMouseOver}
      onMouseLeave={hoverHandlers.onMouseLeave}
      onTouch={onClick}
    >
      <Box
        alignItems="center"
        color={hasHoverState && isHovering ? 'lightGray' : 'white'}
        display="flex"
        flex={isRowItem ? 'shrink' : 'none'}
        height={64}
        width="100%"
      >
        <Box marginLeft={6} marginRight={3} data-test-id="createBoardButton">
          <Icon
            accessibilityLabel={i18n._('Add a board')}
            size="32"
            icon="add-circle"
            color="red"
          />
        </Box>
        {name ? (
          <Box margin={1}>
            <Text inline overflow="normal" __dangerouslyIncreaseLineHeight>
              {' '}
              {i18n._('Create: ')}{' '}
            </Text>
          </Box>
        ) : null}
        <Text truncate align="center" bold inline __dangerouslyIncreaseLineHeight>
          {' '}
          {text}{' '}
        </Text>
      </Box>
    </Touchable>
  );
}

export default hoverable(CreateBoardButton);
